import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import { useNavigate } from "react-router-dom";
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader';
import { TabContext, TabPanel, TabList } from '@mui/lab';
import {Grid, Typography, Box,Tab,useMediaQuery} from "@mui/material";
import ServicesIndex from './Components/ServicesIndex';
import AvailedServicesIndex from './Components/AvailedServicesIndex';
import { Padding } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { fetchData, postData,postFormData } from '../../../redux/apiSlice';
import AuthUser from '../../../Components/Auth/AuthUser';
import swal from "sweetalert";
function MediaServices() {
    const navigate = useNavigate();
    const [value, setValue] = React.useState('1');
    const [freez, setFreez] = React.useState(false);
    const [fetchMedia, setFetchMedia] = useState({});
    const { user, validateRoles } = AuthUser();
    const dispatch = useDispatch();
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : '');
   const [availedService, setAvailedService] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
   
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const isApplicable=async() =>{
        handleFreezStart();
        const apiUrl =  `/isapplicable/${companyId}`;
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res.success == true) {
            fetchMediaService();
            handleFreezStop();
        }else{
            navigate('/login');
            handleFreezStop();
            return false;
        }
    }

    const fetchMediaService = async () => {
            handleFreezStart();
            const apiUrl =  `/getMediaServiceDetails/${companyId}`;
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res.success == true) {
                setFetchMedia(res.data)
                // setAvailedService(true);
                setValue('2');
                handleFreezStop();
            }else if(res.success == false && res.data){
                handleFreezStop();
                setFetchMedia(res.data)
                swal({
                    title: "Info",
                    text: res.message,
                    icon: "info",
                    button: "Ok",
                })
            }else{
                handleFreezStop();
            }
        }
    useEffect(() => {
        isApplicable();
    }, [])
    

    function ContentLayout() {
        return (
            <>
                <Grid container item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant='h5' sx={{ display: "flex", alignItems: "center",fontWeight:"bold" }}>
                        {/* <span><img src={require("../../../assets/images/back.png")} alt="back" style={{ width: 25, height: 25, marginRight: 8  }} /></span> */}
                    Level Up Media Package</Typography>
                </Grid>
                <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                    <img src={require("../../../assets/images/bannerMedia.png")} alt="banner" style={{ width: "100%", height: "auto" }} />
                </Grid>
                <Grid>
                    <Box sx={{ width: '100%',}}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                <TabList
                                    onChange={handleChange}
                                    aria-label="secondary tabs example"
                                    textColor="inherit"
                                    indicatorColor="primary"
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            backgroundColor: '#6CC641', 
                                        },
                                    }}
                                >
                                    <Tab
                                        label="Services"
                                        value="1"
                                        sx={{
                                            textTransform: "capitalize",
                                            fontWeight: "bold",
                                            color: value === "1" ? "#6CC641" : "#000000",
                                            fontSize:"18px"
                                        }}
                                    />
                                    <Tab
                                        label="Your Services"
                                        value="2"
                                        sx={{
                                            textTransform: "capitalize",
                                            fontWeight: "bold",
                                            color: value === "2" ? "#6CC641" : "#000000",
                                            fontSize:"18px"
                                        }}
                                    />
                                </TabList>
                            </Box>
                            <TabPanel value="1" sx={{padding:"10px !important"}}><ServicesIndex setTabValue={setValue} fetchMedia={fetchMedia} fetchMediaService={fetchMediaService}/></TabPanel>
                            <TabPanel value="2" sx={{padding:isMobile?"0px !important":"auto"}}><AvailedServicesIndex /></TabPanel>
                        </TabContext>

                    </Box>
                </Grid>
            </>
        );
    };
    return (
        <div>

            <DefaultLayout content={<ContentLayout />} />
            {/* loader code start */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                // onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div>
            {/* loader code end */}
        </div>
    );
}
export default MediaServices;